import { render, staticRenderFns } from "./Edituser.vue?vue&type=template&id=dbb94280&scoped=true"
import script from "./Edituser.vue?vue&type=script&lang=js"
export * from "./Edituser.vue?vue&type=script&lang=js"
import style0 from "./Edituser.vue?vue&type=style&index=0&id=dbb94280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb94280",
  null
  
)

export default component.exports